import { render, staticRenderFns } from "./AssistantChatWidget.vue?vue&type=template&id=a87c15ea&scoped=true"
import script from "./AssistantChatWidget.vue?vue&type=script&lang=js"
export * from "./AssistantChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AssistantChatWidget.vue?vue&type=style&index=0&id=a87c15ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87c15ea",
  null
  
)

export default component.exports